import { GetColumnsType } from '../../../../../ui/components/TableContainer/types/propsTypes';
import { formatDateDMYYYY } from '../../../../../ui/utils';
import { DynamicObjectInterface } from '../../../../../sdk/type';

type IRewardBO = {
  [key: string]: DynamicObjectInterface;
};

const getRewardListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'rewardName',
    text: translation('admin.rewardMaster.rewardName'),
    sortable: true,
    width: 14,
    render: (object: IRewardBO) => <span>{object.rewardName}</span>,
  },
  {
    key: 'rewardStatus',
    text: translation('admin.rewardMaster.status'),
    sortable: true,
    width: 5,
    render: (object: IRewardBO) => <span>{object.rewardStatus}</span>,
  },
  {
    key: 'modifiedDate',
    text: translation('admin.participant.lastUpdated'),
    sortable: true,
    width: 5,
    render: (object: IRewardBO) => (
      <span>{object.modifiedDate ? formatDateDMYYYY(new Date(object.modifiedDate)) : null}</span>
    ),
  },
];

export default getRewardListConfig;
